// export const API_URL = "http://localhost:2000/"

export const API_URL = "https://identity-insert-variety-romantic.trycloudflare.com/"


// export const API_URL = "https://workboard-backend.onrender.com/"

// export const API_URL = "https://workboard-backend-production.up.railway.app/"


